export default "__VITE_ASSET__CIyPsF7k__";